import Menu from '../Menu';
import './index.css';

export default function Footer() {
  return (
    <>
      <div className="footer">
        <div className="footer-content">
          <Menu />
        </div>
      </div>
    </>
  )
}